import { Box, useThemeUI } from "theme-ui";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import castArray from "lodash/fp/castArray";
import concat from "lodash/fp/concat";
import dropRight from "lodash/fp/dropRight";
import flow from "lodash/fp/flow";
import uniq from "lodash/fp/uniq";

import { selectUserChoiceValues } from "store/app";
import { Progress, HorizontalScrollView } from "components";
import Fields from "./Fields";
import * as styles from "./Customisations.styles";

function Customisations({
  customisations = [],
  selectedCustomisationId,
  UIVersion,
}) {
  const {
    theme: { isMobile, isDesktop },
  } = useThemeUI();

  const userChoiceValues = useSelector(selectUserChoiceValues);

  const [focusedFields, _setFocusedFields] = useState([]);

  const setFocusedFields = flow(
    castArray,
    concat(focusedFields),
    uniq,
    _setFocusedFields
  );

  const goBackFocusedFields = () => _setFocusedFields(dropRight(1));

  const [scrollPositions, setScrollPositions] = useState({});

  useEffect(() => {
    _setFocusedFields([]);
  }, [selectedCustomisationId]);

  const [scrollPositionId] = [
    selectedCustomisationId,
    ...focusedFields,
  ].reverse();

  return (
    <Box sx={styles.customisations({ UIVersion })} data-cy="customisations">
      <Box sx={UIVersion === 2 ? styles.formFieldsV2 : styles.formFields}>
        {isMobile && UIVersion !== 2 ? (
          <Fields
            customisations={customisations}
            selectedCustomisationId={selectedCustomisationId}
            userChoiceValues={userChoiceValues}
          />
        ) : (
          <HorizontalScrollView
            key={selectedCustomisationId}
            sideGutter={20}
            itemGap={20}
            height={isMobile ? 40 : 100}
            sideButtonWidth={isMobile ? 40 : 80}
            scrollPositions={scrollPositions}
            scrollPositionId={scrollPositionId}
            onScroll={(scrollPosition) => {
              setScrollPositions((prev) => ({
                ...prev,
                [scrollPositionId]: scrollPosition,
              }));
            }}
          >
            <Fields
              customisations={customisations}
              selectedCustomisationId={selectedCustomisationId}
              userChoiceValues={userChoiceValues}
              focusedField={focusedFields}
              setFocusedField={setFocusedFields}
              goBackFocusedFields={goBackFocusedFields}
            />
          </HorizontalScrollView>
        )}
      </Box>

      {!isDesktop && UIVersion !== 2 && customisations.length > 1 && (
        <Box sx={styles.progressContainer}>
          <Progress
            tabs={customisations}
            selectedTabId={selectedCustomisationId}
            userChoiceValues={userChoiceValues}
          />
        </Box>
      )}
    </Box>
  );
}

export default Customisations;
